<template>
  <div>
    <v-dialog
      v-model="showModal"
      persistent
      fullscreen
    >
      <div class="content-section">
        <h1 class="header-style">
          Profile Picture
        </h1>
        <br>
        <div class="w-100 text-center">
          <croppa
            ref="croppa"
            v-model="myCroppa"
            :width="300"
            :height="300"
            :accept="'image/*'"
            :placeholder="'Choose profile picture'"
          />
        </div>
        <v-btn
          class="btn-style"
          color="#64CA7F"
          elevation="0"
          @click="uploadCroppedImage"
        >
          Update
        </v-btn>
        <v-btn
          class="btn-style grey-button"
          color="#E2E2E2"
          elevation="0"
          @click="showModal = false"
        >
          Cancel
        </v-btn>
        <v-btn
          fab
          color="#FFF"
          small
          rounded
          elevation="0"
          class="close-button"
          @click="showModal = false"
        >
          <v-icon color="#37474f">
            mdi mdi-close
          </v-icon>
        </v-btn>
      </div>
    </v-dialog>
    <centre-spinner :loading="loading" />
  </div>
</template>

<script>
import Vue from 'vue';
import Croppa from 'vue-croppa';
import 'vue-croppa/dist/vue-croppa.css';
import Constants from 'src/constants';
import spinner from 'src/views/components/SpinnerCentre';

Vue.use(Croppa);

export default {
  name: 'UserProfileImageReview',
  components: {
    'centre-spinner': spinner,
  },
  data () {
    return {
      loading: false,
      showModal: true,
      myCroppa: {},
    };
  },
  computed: {
    checkImageSelected () {
      return !(this.$refs.croppa && this.$refs.croppa.hasImage());
    },
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  methods: {
    uploadCroppedImage () {
      if (this.checkImageSelected) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Please add profile image before uppdating',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }
      this.myCroppa.generateBlob(
        (blob) => {
          if (blob) {
            const reader = new FileReader();
            reader.onload = (e) => {
              const file = new File([blob], 'profile_image.jpg', { type: 'image/jpeg' });
              this.loading = true;
              setTimeout(() => {
                this.$emit('image-created', file);
                this.loading = false;
                this.showModal = false;
              }, 1000);
            };
            reader.readAsDataURL(blob);
          }
        },
        'image/jpeg',
        0.8,
      );
    },
  },
};
</script>

<style scoped></style>
